import React from 'react';
import { useForm } from 'react-hook-form';
import { Form, Modal, ModalContent, ModalHeader } from 'semantic-ui-react';
import { useTranslation } from "react-i18next";

const SelectedRateSpaceModal = ({ rateValues, isOpen, onRequestClose, onSubmitModalForm }) => {

    const { t } = useTranslation();
    const { register, handleSubmit, errors } = useForm();
    const onSubmit = (data) => {
        onSubmitModalForm(data);
    };
    return (
        <Modal size="tiny" open={isOpen} className=''>
            <ModalHeader>{rateValues.error ? t(rateValues.error) : t("select_rate")}</ModalHeader>
            <ModalContent>
                <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col'>
                    <Form.Group className='flex gap-5 mb-8'>
                        {
                            rateValues.rates?.map((rate) => (
                                <Form.Field className='flex flex-col gap-3' >
                                    <label className='font-semibold'>
                                        {
                                            rate.airplaneTicket ?
                                                t("space_ratePriceInclude")
                                                :
                                                t("space_ratePriceNotInclude")
                                        }
                                    </label>
                                    <span className="text_date_format uppercase mt-[-14px]">{rate.rateType}</span>
                                    <div className="flex flex-col gap-3">
                                        <div className="flex gap-3">
                                            <label className='font-semibold text-sky-700'>$ {rate.rateClientPrice}</label>
                                            <input
                                                type="radio"
                                                name='rate_id'
                                                value={rate.rateId}
                                                ref={register({ required: true })}
                                            />
                                            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
                                        </div>
                                    </div>
                                </Form.Field>
                            ))
                        }
                    </Form.Group>
                    <div className='flex justify-start'>
                        {
                            !rateValues.error ?
                                <button
                                    type="submit"
                                    className={"ui primary button "}
                                >
                                    {t("save_button")}
                                </button> : " "
                        }
                        <button type="button" className="ui button" onClick={onRequestClose}>
                            {t("canceled_button")}
                        </button>
                    </div>
                </form>
            </ModalContent>
        </Modal>
    );
};

export default SelectedRateSpaceModal;